import { registerPlugin } from '@capacitor/core';
const Sim = registerPlugin('Sim', {});
export * from './definitions';
export { Sim };
//# sourceMappingURL=index.js.map